<template>
  <div class="chat-coming-soon-banner">
    <div class="background-container">
      <!-- Removed text-left and text-right -->
    </div>
   
  </div>
</template>

<script>
export default {
  name: 'ChatBannerComponent',
};
</script>

<style lang="scss" scoped>
.chat-coming-soon-banner {
  background-image: url("../assets/images/ExpertBuzzMainBanner(Web).svg");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;

  .lable-outer {
    display: flex;
    justify-content: center;
    position: relative;

    .chat-label {
      position: absolute;
      bottom: 0px;
      width: 250px;
    }
  }

  .background-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 5px 20px 15px;
    height: 83px;
  }

  .coming-soon-banner-container {
    position: absolute;
    top: 23%;
    left: 55%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .coming-soon-banner {
    display: inline-block;
    text-align: center;
    font-size: 10px;
    font-weight: 500;
    color: #ffffff;
    padding: 10px 20px;
    background-color: #df6052;
    border-radius: 8px;
    white-space: nowrap;
  }
}

@media screen and (max-width: 1100px) {
  .chat-coming-soon-banner {
    border-radius: 0px 0px 20px 20px;

    .features-list {
      display: none;
    }

    .background-container {
      height: 60px;
    }
  }
}

@media screen and (max-width: 900px) {
  .chat-coming-soon-banner {

    .background-container {
      height: 50px;
    }
  }
}

@media screen and (max-width: 770px) {
  .chat-coming-soon-banner {
    .background-container {
      height: 30px;
    }
  }
}
@media screen and (max-width: 450px) {
  .chat-coming-soon-banner {
    background-image: url("../assets/images/ExpertBuzz Main Banner (Mobile).svg");
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;

    .background-container {
      padding: 5px 0px;
      height: 70px;
    }
  } 
}

</style>